import React from 'react'
import { AttachmentListRespType, AttachmentType } from '../../models'
import { RowLayout } from '../RowLayout'

export const OverviewRowAttachments = (params: {
  text: string
  attachmentList: AttachmentListRespType[] | undefined
  attachmentType: AttachmentType
}) => {
  const filteredAttachmentList = params.attachmentList?.filter(
    (it) => it?.attachmentType === params.attachmentType
  )

  if (filteredAttachmentList?.length === 0) {
    return null
  } else {
    return (
      <RowLayout
        text={params.text}
        data={filteredAttachmentList?.map((it) =>
          it?.attachments?.map((att, index) => (
            <div key={index}>{att.fileName}</div>
          ))
        )}
      />
    )
  }
}
